import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/license/assign_to_all";

export class LicenseModulesAssignToAllCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: AssignToAllReqData = null;

    constructor(payload: AssignToAllReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<AssignToAllResData> {
        var res = await this.executeCommand(this.payload, null, null);
        return new AssignToAllResData(res);
    }
}

export interface AssignToAllReqData {
    licenseModule: LicenseModuleEnum;
}

export class AssignToAllResData extends ServiceResponseData {
    installationNames: string[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationNames = [];
        if (response.data && response.data.Payload && response.data.Payload.length > 0) {
            this.installationNames = response.data.Payload;
        }
    }
}
